import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from 'components/InfoPage';

export const path = '/privacy';
export const link = path;

const Privacy = props => {
    const [t] = useTranslation("privacy");
    return <InfoPage t={t} />
}

Privacy.path = path;

export default Privacy;
